resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*

  Calendar

  Calendar (date picker) widget that displays a given month/year and allows monthly forwards and
  backwards navigation. Allows user to select a single date.

  Arguments:
    defaultDate (optional) [Date object]:
      Defaults to today. Default date the calendar should display. This argument is ignored
      if there is a default selected value.
    value (optional) [Date object]:
      Defaults to null. Default selected date.
    onSelectionCallback (optional) [function]:
      Callback function that is called when the user selects a date.
    disableweekends (optional) [boolean]: (Jade attribute starts with `data-mogo-ui-calendar-`)
      Defaults to false. Disables weekends so that they cannot be selected.
    disableAvailability (optional) [Array]: (Jade attribute starts with `data-mogo-ui-calendar-`)
      An array consisting of functions (rules) and/or Dates that should be disabled so that
      they cannot be selected.
    disablefuturedates (optional) [boolean]: (Jade attribute starts with `data-mogo-ui-calendar-`)
      Default false.  Disable selection of dates in the future
    disablebeforexyearsback (optional) [integer]: (Jade attribute starts with `data-mogo-ui-calendar-`)
      Default null.  Disable selection of dates before this many years before the current date.
    firstValidDate (optional) [string]: Ignored if disableAvailability defined. Date before which no dates are valid. Possible values: 'today', 'tomorrow', 'yesterday', 'add \d {days|months|years}', 'subtract \d {days|months|years}', a date in that can be parsed by a 'new Date()' call.
    lastValidDate (optional) [string]: Ignored if disableAvailability defined. Date after which no dates are valid. Format follows firstValidDate.
    wizard (optional) [boolean]: (Jade attribute starts with `data-mogo-ui-calendar-`)
      Defaults to false.  Enable 3 step selection wizard view. User chooses Year then Month then day.
    initialdecade (optional) [integer]: (Jade attribute starts with `data-mogo-ui-calendar-`)
      Default 1900.  For wizard mode only. Sets the decade step 1 initially loads.
*/

function Calendar() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;
  this.extends = [_Input];

  // Parameters
  this.defaultDate = new Date();
  this.value = null;
  this.onSelectionCallback = function(date) {};
  this.disableAvailability = [];
  this.firstValidDate = undefined;
  this.lastValidDate = undefined;

  // options that can be passed up from jade via parent TextField Component (lowercase required):
  this.wizard = null;
  this.initialdecade = 1900;
  this.disableweekends = false;
  this.disablefuturedates = false;
  this.disablebeforexyearsback = null;


  this._dow = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  this._dowAbbr = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  this._months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  this._monthsAbbr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  this._titleNode = null;

  this._calNode = null;

  this._calNodeYear = null;
  this._calNodeMonth = null; //TODO: we should not need this
  this._calNodeDay = null; //TODO: we should not need this either

  this._curYear = null;
  this._curMonth = null;
  this._curDay = null;

  // new set just for showing selected states...
  this.showPreviousSelections = true; // highlight previously selected year & month & day when navigating steps
  this._lastChosenYear = null;
  this._lastChosenMonth = null;
  this._lastChosenDay = null;

  this._curFocused = null;
  this._hiddenInput = null;

  this.html = {
    "container" : "<div class='mogo-ui-calendar'></div>",
    "header"    : "<div class='header'></div>",
    "title"     : "<div class='title'></div>",
    "calTable"  : "<table class='calendar'><tbody></tbody></table>",
    "leftIcon"  : "<a class='prev' href='#'><span class='icon-arrowleft'></span><span class='a11yTxt'>Previous</span></a>",
    "rightIcon" : "<a class='next' href='#'><span class='icon-arrowright'></span><span class='a11yTxt'>Next</span></a>"
  }

  this._debugMode = false;

  this.init = function() {
    this.$node = $(this.node);

    if (this._debugMode) console.log ("Calendar.wizard: (%s)", this.wizard);
    if (this._debugMode) console.log ("Calendar.initialdecade: (%s)", this.initialdecade);
    if (this._debugMode) console.log ("Calendar.disableweekends: (%s)", this.disableweekends);
    if (this._debugMode) console.log ("Calendar.disablefuturedates: (%s)", this.disablefuturedates);
    if (this._debugMode) console.log ("Calendar.disablebeforexyearsback: (%s)", this.disablebeforexyearsback);

    if (this.wizard) {
      $(this.node).addClass("wizard-mode");
      // Init values
      this._initValues();
      // Create hidden input if necessary
      this._generateHiddenInput();
      this._createYearStructure();
      // Initialize _Input for error handling
      this._super();
      // Initialize accessibility features
      this._generateGeneralAccessibility();
      // Generate calendar
      this._generateYearData(this.defaultDate.getFullYear());
      // Initialize connections
      this._generateGeneralConnections();
    } else {
      // Init values
      this._initValues();
      // Create skeleton HTML
      this._createDayStructure();
      // Create hidden input if necessary
      this._generateHiddenInput();
      // Initialize _Input for error handling
      this._super();
      // Initialize accessibility features
      this._generateGeneralAccessibility();
      // Generate calendar
      this._generateDayData(this.defaultDate.getMonth(), this.defaultDate.getFullYear());
      // Initialize connections
      this._generateGeneralConnections();
      // Set initial focus
      this._curFocused = new Date(this.defaultDate.getTime());
      this._setTabIndex(this._curFocused);
    }

  };

  this.initAllReady = function() {
      this.showCal();
  };

  this.showCal = function() {
    this.$node.css("display", "inline-block");
  };

  this.resetCalViews = function() {
    // happens after day is selected (new date is picked)
    if (this.wizard) {
      this.$node.find(".month-view").removeClass("active-view").hide();
      this.$node.find(".day-view").removeClass("active-view").hide();
      this.$node.find(".year-view").addClass("active-view").show();// set default state...kinda
      // this.$node.css("display", "none");

      this._clearLastChosenSelections();
      this._curYear = null;
      this._curMonth = null;
      this._curDay = null;

      this._generateYearData(this.defaultDate.getFullYear()); // reset
      // alternatively could find ALL 'selected' classes and remove them.
    }
  };


  this.val = function(newValue) { // Date object or YYYY-MM-DD format
    if (newValue == null) {
      // Return value
      if (this.value != null)
        return this.value.getFullYear() + "-" + ("0" + (this.value.getMonth() + 1)).slice(-2) + "-" + ("0" + this.value.getDate()).slice(-2);
      else
        return "";
    } else if (newValue instanceof Date) {
      // Assign value (Date object)
      if (this._checkAvailability(newValue))
        this.value = new Date(newValue.getTime());
    } else if (typeof newValue == "string") {
      // Assign value (YYYY-MM-DD)
      if (newValue != "") {
        var temp = newValue.split("-");
        if (temp.length != 3 || temp[0].length != 4 || temp[1].length != 2 || temp[2].length != 2 || !this._isValidDate(temp[0], parseInt(temp[1]) - 1, temp[2]) || !this._checkAvailability(new Date(temp[0], parseInt(temp[1]) - 1, temp[2]))) {
          return;
        }
        this.value = new Date(temp[0], parseInt(temp[1]) - 1, temp[2]);
      } else {
        this.value = null;
      }
    }

    // DV-3256: In order to support the pre-existing birth date sent by the BE 
    // we are disabling the set focus and refresh month calender views
    // so now after every selection, calender view will be reset to initialdecade 

    // Set focus
    // if (this.value != null) {
    //   if (this.value.getFullYear() != this._curYear || this.value.getMonth() != this._curMonth) {
    //     this._curFocused = new Date(this.value.getTime());
    //   }
    // }

    // // Refresh calendar view to correct month/year
    // if (this.value != null) {
    //   var newValMonth = this.value.getMonth();
    //   var newValYear = this.value.getFullYear();

    //   if (newValMonth != this._curMonth || newValYear != this._curYear) {
    //     // this breaks something in calendar:
    //     this._generateDayData(newValMonth, newValYear);
    //   }
    // }

    // // Selected styles and accessibility
    // $("td", this._calNode).removeClass("selected");
    // $("td[aria-selected='true']", this._calNode).attr("aria-selected", "false");
    // if (this.value != null) {
    //   $("td[data-day='" + this.value.getDate() + "']", this._calNode).addClass("selected");
    //   $("td[data-day='" + this.value.getDate() + "']", this._calNode).attr("aria-selected", "true");
    // }

    // Set focus
    this._setTabIndex(this._curFocused);

    // Update hidden input if necessary
    if (this._hiddenInput != null) {
      if (this.value != null)
        $(this._hiddenInput).val(this.value.getFullYear() + "-" + ("0" + (this.value.getMonth() + 1)).slice(-2) + "-" + ("0" + this.value.getDate()).slice(-2));
      else
        $(this._hiddenInput).val("");
    }
  };

  this.setAvailability = function(arr, init) {
    this.disableAvailability = arr;
    if (this.disableweekends) {
      this.disableAvailability.push(this._isNotWeekendDate);
    }
    if (this.disablefuturedates) {
      this.disableAvailability.push(this._isNotFutureDate);
    }
    if (this.disablebeforexyearsback) {
      this.disableAvailability.push($.proxy(this._isNotBeforeXYearsBackDate, this));
    }

    if (init == null || !init) {
      if (this.value) {
        this._generateDayData(this.value.getMonth(), this.value.getFullYear());
      } else {
        this.defaultDate = this._getClosestAvailableDate(new Date());
        this._generateDayData(this.defaultDate.getMonth(), this.defaultDate.getFullYear());
      }

      if (!this._checkAvailability(this.value)) {
        this.value = null;
      }
    }
  };

  this._initValues = function() {
    // Set availability
    if (this.disableAvailability.length === 0 && (this.firstValidDate || this.lastValidDate)) {
      if (this.firstValidDate) {
        var firstDateObj = this._parseBookendDate(this.firstValidDate);
      }
      if (this.lastValidDate) {
        var lastDateObj = this._parseBookendDate(this.lastValidDate);
      }
      this.disableAvailability = new Array(function (testDate) {
        var isValidDate = true;
        if (firstDateObj && firstDateObj > testDate) {
          isValidDate = false;
        }
        if (lastDateObj && lastDateObj < testDate) {
          isValidDate = false;
        }
        return isValidDate;
      });
    }
    this.setAvailability(this.disableAvailability, true);

    // Set default value
    if (this.value != null) {
      this.defaultDate = new Date(this.value.getTime());
    } else if (this.wizard) {
      this.defaultDate = new Date(this.initialdecade, 0, 1);
    } else {
      this.defaultDate = this._getClosestAvailableDate(new Date());
    }

    // Set focus
    this._curFocused = new Date(this.defaultDate.getTime());
  };




  // STRUCTURES  .................................................................................

  this._createYearStructure = function() {

    // Create main calendar container div
    this.containerDiv = $(this.html.container);  //NOTE: this.containerDiv  is required by Input field init.
    this._yearViewWrapper = $("<div class='year-view'></div>").appendTo(this.containerDiv);

    // Create heading for month-year
    this._titleNode = $(this.html.header).appendTo(this._yearViewWrapper);
    $(this.html.title).appendTo(this._titleNode);

    // Create prev/next month links
    $(this.html.leftIcon + this.html.rightIcon).appendTo(this._titleNode);

    // Create calendar structure
    this._calNodeYear = $(this.html.calTable).appendTo(this._yearViewWrapper);

    this.$node.append(this.containerDiv);

  };

  this._createMonthStructure = function() {

    //guard
    if(!this.$node.find("div").hasClass("month-view")) {

      // Create main calendar container div
      this.containerDiv = $(this.html.container);
      this._monthViewWrapper = $("<div class='month-view'></div>").appendTo(this.containerDiv);

      // Create heading for month-year
      this._titleNode = $(this.html.header).appendTo(this._monthViewWrapper);
      $(this.html.title).appendTo(this._titleNode);

      // Create prev/next year links
      $(this.html.leftIcon + this.html.rightIcon).appendTo(this._titleNode);

      // Create calendar structure
      this._calNodeMonth = $(this.html.calTable).appendTo(this._monthViewWrapper);

      this.$node.append(this.containerDiv);
    }
  };

  this._createDayStructure = function() {

    //guard
    if(!this.$node.find("div").hasClass("day-view")) {

      // Create main calendar container div
      this.containerDiv = $(this.html.container);
      this._dayViewWrapper = $("<div class='day-view'></div>").appendTo(this.containerDiv);

      // Create heading for month-year
      this._titleNode = $(this.html.header).appendTo(this._dayViewWrapper);
      $(this.html.title).appendTo(this._titleNode);

      // Create prev/next month links
      $(this.html.leftIcon + this.html.rightIcon).appendTo(this._titleNode);

      // Create calendar structure
      this._calNode = $(this.html.calTable).appendTo(this._dayViewWrapper);
      // Days of the week header:
      $("<thead><tr></tr></thead>").prependTo(this._calNode);
      var trNode = $("tr", this._calNode);
      for (var i = 0; i < 7; i++) {
        $("<th title='" + this._dow[i] + "'>" + this._dowAbbr[i] + "</th>").appendTo(trNode);
      }

      this.$node.append(this.containerDiv);

    }

  };

  this._generateHiddenInput = function() {
    // Create hidden input if necessary
    if ($(this.node).attr("name") != null || this.name != null) {
      var name = $(this.node).attr("name") || this.name;
      $(this.node).attr("name", "");
      this._hiddenInput = $("<input type='text' name='" + name + "' />").appendTo(this.node);
    }
  };



  // DATA POP  .................................................................................

  //years in decade
  this._generateYearData = function(year) {

    var _firstYearInDecade = year;
    var _lastYearInDecade = new Date();
    _lastYearInDecade.setYear(_firstYearInDecade + 9);
    var firstDay = new Date(_firstYearInDecade, 0, 1);
    var prevYear = new Date(_firstYearInDecade, 0, 1);
    prevYear.setFullYear(firstDay.getFullYear() - 1);
    var lastYear = new Date();
    lastYear.setFullYear(firstDay.getFullYear() + 10);

    var iRow = 0;


    // Generate year range
    var $viewWrapper = this.$node.find(".year-view");
    $viewWrapper.find(".title").html(_firstYearInDecade + " - " + _lastYearInDecade.getFullYear());

    var tableBody = $viewWrapper.find("tbody");
    $(tableBody).html("");


    // Generate previous decade year
    var trNode = $("<tr></tr>").appendTo(tableBody);
    $("<td class='notInViewSet'>" + prevYear.getFullYear() + "</td>").appendTo(trNode);

    // Generate current decade month
    var theYear = firstDay;
    iRow = 1;//already started with previous year so bump this up....
    trNode = trNode[trNode.length - 1];

    while (theYear.getFullYear() < lastYear.getFullYear()) {
      if (iRow == 4) {
        iRow = 0;
        trNode = $("<tr></tr>").appendTo(tableBody);
      }

      // Generate classes
      var className = " class='";

      // Is Year Available?
      var available = this._checkAvailability(theYear);
      if (!available)
        className = className + "unavailable ";

      // Is Current Year?
      var todaysYear = new Date().getFullYear();
      if (theYear.getFullYear() == todaysYear) {
        className = className + "thisyear";
      }

      // Is Previously Selected?
      if (this.showPreviousSelections && theYear.getFullYear() == this._lastChosenYear) {
        className = className + " selected";
      }

      className = className + "'";

      // Generate td
      var td = $("<td tabindex='-1'" + className + ">" + theYear.getFullYear() + "</td>").appendTo(trNode);
      $(td).attr("data-year", theYear.getFullYear());
      theYear.setFullYear(theYear.getFullYear() + 1);
      iRow++;
    }

    // Generate next decade years
    $("<td class='notInViewSet'>" + lastYear.getFullYear() + "</td>").appendTo(trNode);


    // Generate connections
    this._curYear = year;// need a default for next/prev decades... do after generating values to avoid selected indicator.
    this._generateViewConnections(tableBody,this._onSelectYear);

    // Generate accessibility
    this._generateCalendarAccessibility();

    this._setActiveView("year");

  };

  // months in year
  this._generateMonthData = function(year) {
    this._curYear = year;

    // Generate year range
    var $viewWrapper = this.$node.find(".month-view");
    $viewWrapper.find(".title").html(year);

    // Set variables
    var firstMonth = new Date(year, 0, 1);
    var iRow = 4;
    var tableBody = $viewWrapper.find("tbody");


    $(tableBody).html("");

    // Generate current months
    var curYear = firstMonth.getFullYear();
    var theMonth = firstMonth;
    var trNode = $("tr", tableBody);

    trNode = trNode[trNode.length - 1];
    while (theMonth.getFullYear() == curYear) {
      var m = theMonth.getMonth();
      if (iRow == 4) {
        iRow = 0;
        trNode = $("<tr></tr>").appendTo(tableBody);
      }

      // Generate classes
      var className = " class='";

      // Is Month Available?
      var available = this._checkAvailability(theMonth);
      if (!available)
        className = className + "unavailable ";

      // Is Current Month?
      var todayMonth = new Date().getMonth();
      var todayYear = new Date().getFullYear();
      if (theMonth.getMonth() == todayMonth && theMonth.getFullYear() == todayYear) {
        className = className + "today";
      }

      // Is Previously Selected?
      if (this.showPreviousSelections && theMonth.getFullYear() == this._lastChosenYear && theMonth.getMonth() == this._lastChosenMonth) {
        className = className + " selected";
      }

      className = className + "'";

      // Generate td
      var td = $("<td tabindex='-1'" + className + ">" + this._monthsAbbr[m] + "</td>").appendTo(trNode);
      $(td).attr("data-month", m);
      theMonth.setMonth(theMonth.getMonth() + 1);
      iRow++;
    }

    // Generate connections
    this._generateViewConnections(tableBody,this._onSelectMonth);

    // Generate accessibility
    this._generateCalendarAccessibility();

    this._setActiveView("month");

  };

  // days in month
  this._generateDayData = function(month, year) {
    this._curMonth = month;
    this._curYear = year;

    // Generate month/year

    this.$node.find(".day-view").find(".title").html(this._months[month] + " " + year);

    // Set variables
    var firstDay = new Date(year, month, 1);
    var firstDow = firstDay.getDay();
    var iRow = 0;
    // var tableBody = $("tbody", this._calNode);///////////hmmmm
    var tableBody = this.$node.find(".day-view").find("tbody"); //TODO: make better

    var todayMonth = new Date().getMonth();
    var todayDate = new Date().getDate();
    var todayYear = new Date().getFullYear();
    $(tableBody).html("");

    // Generate previous month
    if (firstDow != 7) {
      var prevDay = new Date(firstDay.getTime());
      prevDay.setDate(prevDay.getDate() - firstDow - 1);
      var trNode = $("<tr></tr>").appendTo(tableBody);
      for (var i = 0; i < firstDow; i++) {
        prevDay.setDate(prevDay.getDate() + 1);

        var today = "";
        if (prevDay.getMonth() == todayMonth && prevDay.getDate() == todayDate)
          today = " today";

        $("<td class='notInViewSet" + today + "'>" + prevDay.getDate() + "</td>").appendTo(trNode);
        iRow++;
      }
    }

    // Generate current month
    var curMonth = firstDay.getMonth();
    var theDay = firstDay;
    var trNode = $("tr", tableBody);
    trNode = trNode[trNode.length - 1];
    while (theDay.getMonth() == curMonth) {
      if (iRow == 7) {
        iRow = 0;
        trNode = $("<tr></tr>").appendTo(tableBody);
      }

      // Generate classes
      var className = " class='";

      // Is Day Available?
      var available = this._checkAvailability(theDay);
      if (!available)
        className = className + "unavailable ";

      // Today
      if (theDay.getMonth() == todayMonth && theDay.getDate() == todayDate && theDay.getFullYear() == todayYear)
        className = className + "today";

      // Is Previously Selected?
        if (this.showPreviousSelections && theDay.getFullYear() == this._lastChosenYear && theDay.getMonth() == this._lastChosenMonth && theDay.getDate() == this._lastChosenDay) {
          className = className + " selected";
        }

      className = className + "'";

      // Generate td
      var td = $("<td tabindex='-1'" + className + ">" + theDay.getDate() + "</td>").appendTo(trNode);
      $(td).attr("data-day", theDay.getDate());
      theDay.setDate(theDay.getDate() + 1);
      iRow++;
    }

    // Generate next month
    var remainingDays = 7 - iRow;
    if (remainingDays != 0) {
      for (var i = 0; i < remainingDays; i++) {
        var today = "";
        if (theDay.getMonth() == todayMonth && theDay.getDate() == todayDate)
          today = " today";

        $("<td class='notInViewSet" + today + "'>" + theDay.getDate() + "</td>").appendTo(trNode);
        theDay.setDate(theDay.getDate() + 1);
      }
    }

    // Generate connections
    this._generateViewConnections(tableBody,this._onSelectDay);

    // Generate accessibility
    this._generateCalendarAccessibility();

    // TODO: turn this back on again:
    // Set selected value
    // if (this.value != null && this.value.getMonth() == this._curMonth && this.value.getFullYear() == this._curYear) {
    //   this.val(this.value);
    // }

    this._setActiveView("day");

  };



  // Accessibility  .................................................................................

  this._generateGeneralAccessibility = function() {
    // Set tab index to node
    this.$node.attr("tabindex", "0");

    // Set role to Application - Calendar
    this.$node.attr("role", "application");

    // Set role for Month - Year header
    $(this._titleNode).attr("role", "heading");

    // Set role for main calendar area
    $(this._calNode).attr("role", "grid");
  };

  this._generateCalendarAccessibility = function() {
    var tds = $("td:not(.notInViewSet)", this._calNode)
    for (var i = 0; i < tds.length; i++) {
      $(tds[i]).attr("aria-selected", "false");
      // $(tds[i]).on("blur", $.proxy(this._calBlur, this)); breaks year and month views
    }

    tds = $("td.unavailable", this._calNode);
    for (var i = 0; i < tds.length; i++) {
      $(tds[i]).attr("aria-disabled", "true");
    }
  };

  this._handleKeyDownEvents = function(e) {
    if (e.which >= 37 && e.which <= 40) {
      // Handle key events that are up/down/left/right

      // Stop event propagation
      e.preventDefault();

      if ($(e.target).parents(".header").length > 0) {
        // Target originated from header

        if (e.which == 37 || e.which == 38) {
          // Left/up arrow
          this.prevMonth();
        } else if (e.which == 39 || e.which == 40) {
          // Right/down arrow
          this.nextMonth();
        }
      } else if (e.target.tagName == "TD") {
        // Target originated from cell

        if (e.which == 37) {
          // Left arrow
          this._moveFocus(-1);
        } else if (e.which == 39) {
          // Right arrow
          this._moveFocus(1);
        } else if (e.which == 38) {
          // Up arrow
          this._moveFocus(-7);
        } else if (e.which == 40) {
          // Down arrow
          this._moveFocus(7);
        }
      }
    } else if (e.which == 13 || e.which == 32) {
      // Handle key event enter and spacebar

      if (e.target.tagName == "TD") {
        // Target originated from cell

        // Prevent default
        e.preventDefault();

        this._onSelectDay(e);
      }
    }
  };

  this._setTabIndex = function(theDate) {
    var $fixedCalNode = this._calNode || this.$node.find(".mogo-ui-calendar").children(".active-view");

    // Insert the current day into the tab order (exclude the rest) (DAYS)
    if (this._curMonth == theDate.getMonth() && this._curYear == theDate.getFullYear()) {
      $("td:not(.notInViewSet)", this._calNode).attr("tabindex", "-1");
      $("td[data-day='" + theDate.getDate() + "']", this._calNode).attr("tabindex", "0");
    } else if (this._curYear == theDate.getFullYear()) {
      $fixedCalNode.find("td:not(.notInViewSet)").attr("tabindex", "-1");
      $fixedCalNode.find("td[data-day='" + theDate.getFullYear() + "']").attr("tabindex", "0");
    }
  };

  // this._moveFocus : onKeypress move focus forward or back a day or week....
  this._moveFocus = function(delta) {
    this._curFocused.setDate(this._curFocused.getDate() + delta);
    if (this._curFocused.getMonth() != this._curMonth || this._curFocused.getFullYear() != this._curYear) {
      this._generateDayData(this._curFocused.getMonth(), this._curFocused.getFullYear());
    }
    this._setTabIndex(this._curFocused);
    $("td[data-day='" + this._curFocused.getDate() + "']", this._calNode).focus();
  };


  this._generateNewFocusMonth = function(delta) {
    // Set new focus
    if (this._curFocused.getMonth() != this._curMonth || this._curFocused.getFullYear() != this._curYear) {
      // Get current years, months days
      var tYears = this._curFocused.getFullYear();
      var tMonths = this._curFocused.getMonth();
      tMonths++; // normalize to 12 months in a year
      var tDays = this._curFocused.getDate();

      // Delta month
      tMonths = tMonths + delta;
      if (tMonths > 12) {
        tYears = tYears + Math.floor(tMonths/12);
        tMonths = tMonths % 12;
      }
      tMonths--; // decrement months to Date format
      if (tMonths == -1) {
        // Previous year
        tYears--;
        tMonths = 11;
      }

      // Check for valid date
      if (this._isValidDate(tYears, tMonths, tDays)) {
        this._curFocused = new Date(tYears, tMonths, tDays);
        this._setTabIndex(this._curFocused);
      } else {
        while (!this._isValidDate(tYears, tMonths, tDays)) {
          tDays--;
        }
        this._curFocused = new Date(tYears, tMonths, tDays);
        this._setTabIndex(this._curFocused);
      }
    }
  };



  // BIND EVENTS  .................................................................................

  this._generateGeneralConnections = function() {
    var currentlyActiveCalendar = this.$node.find(".mogo-ui-calendar").children(".active-view");

    if($(currentlyActiveCalendar).hasClass("year-view")) {
      $(currentlyActiveCalendar).find(".next").off('click').on("click", $.proxy(this.nextDecade, this));
      $(currentlyActiveCalendar).find(".prev").off('click').on("click", $.proxy(this.prevDecade, this));
      // $(this.node).on("keydown", $.proxy(this._handleKeyDownEvents, this));
    } else

    if($(currentlyActiveCalendar).hasClass("month-view")) {
      $(currentlyActiveCalendar).find(".next").off('click').on("click", $.proxy(this.nextYear, this));
      $(currentlyActiveCalendar).find(".prev").off('click').on("click", $.proxy(this.prevYear, this));
      // $(this.node).on("keydown", $.proxy(this._handleKeyDownEvents, this));
        $(currentlyActiveCalendar).find("div.title").off('click').on("click", $.proxy(this.backToAllYears, this));
    } else

    if($(currentlyActiveCalendar).hasClass("day-view")) {
      $(currentlyActiveCalendar).find(".next").off('click').on("click", $.proxy(this.nextMonth, this));
      $(currentlyActiveCalendar).find(".prev").off('click').on("click", $.proxy(this.prevMonth, this));
      this.$node.on("keydown", $.proxy(this._handleKeyDownEvents, this));
      if (this.wizard) {
        $(currentlyActiveCalendar).find("div.title").off('click').on("click", $.proxy(this.backToAllMonths, this));
      }
    }

  };

  this._generateViewConnections = function(tb,action) {
    var tds = $(tb).find("td:not(.notInViewSet)");
    for (var i = 0; i < tds.length; i++) {
      $(tds[i]).on("click", $.proxy(action, this));
    }
  };

  this._calBlur = function() {
    this.$node.trigger("calBlur");
  };


  // EVENT ACTIONS  .................................................................................

  this._onSelectYear = function(e) {
    var newYear = $(e.target).data("year");
    var d = new Date(newYear, this._curMonth, this._curDay);
    this._curFocused = d;// hmmmmmmmmmmmmmmmm

    if (this._checkAvailability(d)) {
      this._setLastChosenYear(newYear);
      this._createMonthStructure();
      this._generateMonthData(newYear);
      this._generateGeneralConnections();
    }

  };

  this._onSelectMonth = function(e) {
    var newMonth = $(e.target).data("month");
    var d = new Date(this._curYear, newMonth, this._curDay);
    this._curFocused = d;// hmmmmmmmmmmmmmmmm

    if (this._checkAvailability(d)) {
      this._setLastChosenMonth(newMonth);
      this._createDayStructure();
      this._generateDayData(newMonth, this._curYear);
      this._generateGeneralConnections();
    }
  };

  this._onSelectDay = function(e) {
    var newDate = $(e.target).data("day");
    this._curDay = newDate;

    var d = new Date(this._curYear, this._curMonth, newDate);
    this._curFocused = d;
    if (this._checkAvailability(d)) {
      this._setLastChosenDay(d);
      this.val(d);
      if (this._hiddenInput != null)
        this._hiddenInput.trigger("change");
      this.onSelectionCallback(d);

      // DV-3256: In order to support the pre-existing birth date sent by the BE 
      // we reset the calender view to initialdecade after each selection
      this.resetCalViews();
      
      // if (this.wizard) {
      //   this.resetCalViews();
      // }

    }
  };

  this._setLastChosenYear = function(d) {
    if (this.showPreviousSelections) {
      if (d != this._lastChosenYear) {
        this._lastChosenMonth = null;
        this._lastChosenDay = null;
      }
      this._lastChosenYear = d;
    }
  };

  this._setLastChosenMonth = function(d) {
    if (this.showPreviousSelections) {
      if (d != this._lastChosenMonth) {
        this._lastChosenDay = null;
      }
      this._lastChosenYear = this._curYear;
      this._lastChosenMonth = d;
    }
  };

  this._setLastChosenDay = function(d) {
    if (this.showPreviousSelections) {
      this._lastChosenYear = this._curYear;
      this._lastChosenMonth = this._curMonth;
      this._lastChosenDay = d;
    }
  };

  this._clearLastChosenSelections = function() {
    this._lastChosenYear = null;
    this._lastChosenMonth = null;
    this._lastChosenDay = null;
  };

  this.nextMonth = function(e) {
    if (e) e.preventDefault();

    this._curMonth++;
    if (this._curMonth == 12) {
      this._curMonth = 0;
      this._curYear++;
    }
    this._generateDayData(this._curMonth, this._curYear);
    this._generateNewFocusMonth(1);

    return false;
  };

  this.prevMonth = function(e) {
    if (e) e.preventDefault();

    this._curMonth--;
    if (this._curMonth == -1) {
      this._curMonth = 11;
      this._curYear--;
    }
    this._generateDayData(this._curMonth, this._curYear);
    this._generateNewFocusMonth(-1);

    return false;
  };

  this.backToAllYears = function(e) {
    if (e) e.preventDefault();

    var firstYearInCurrentDecade = Math.floor(this._curYear/10)*10;
    this._generateYearData(firstYearInCurrentDecade);

    return false;
  };

  this.backToAllMonths = function(e) {
    if (e) e.preventDefault();

    this._generateMonthData(this._curYear);
    this._setActiveView("month");

    return false;
  };

  this.nextYear = function(e) {
    if (e) e.preventDefault();
    this._curYear++;
    this._generateMonthData(this._curYear);
    // this._generateNewFocusMonth(1);

    return false;
  };

  this.prevYear = function(e) {
    if (e) e.preventDefault();
    this._curYear--;
    this._generateMonthData(this._curYear);
    // this._generateNewFocusMonth(-1);

    return false;
  };

  this.nextDecade = function(e) {
    if (e) e.preventDefault();
    var nextDec = this._curYear+10;
    this._generateYearData(nextDec);
    // this._generateNewFocusMonth(1);

    return false;
  };

  this.prevDecade = function(e) {
    if (e) e.preventDefault();
    var prevDec = this._curYear-10;
    this._generateYearData(prevDec);
    // this._generateNewFocusMonth(-1);

    return false;
  };


  // HELPERS  .................................................................................

  this._setActiveView = function(view) {
    this.$node.find(".year-view, .month-view, .day-view").removeClass("active-view").hide();
    this.$node.find("."+view+"-view").addClass("active-view").show();
  };

  this._isValidDate = function(year, month, day) {
    var d = new Date(year, month, day);
    return (year == d.getFullYear() && month == d.getMonth() && day == d.getDate());
  };

  this._checkAvailability = function(theDate) {
    for (var i = 0; i < this.disableAvailability.length; i++) {
      var rule = this.disableAvailability[i];
      if (typeof rule == "function") {
        if (!rule(theDate))
          return false;
      } else if (rule instanceof Date) {
        if (theDate.getFullYear() == rule.getFullYear() &&
          theDate.getMonth() == rule.getMonth() &&
          theDate.getDate() == rule.getDate())
            return false;
      }
    }

    return true;
  };

  this._getClosestAvailableDate = function(theDate){
    if (this._checkAvailability(theDate)) {
      return theDate;
    } else {
      var i = 1;
      var max = 7300; // +/-20 years
      while (!this._checkAvailability(theDate)) {
        var fDate = new Date(theDate.getTime());
        var bDate = new Date(theDate.getTime());
        fDate.setDate(fDate.getDate() + i);
        bDate.setDate(bDate.getDate() - i);
        if (this._checkAvailability(fDate))
          return fDate;
        else if (this._checkAvailability(bDate))
          return bDate;
        i++;

        if (i > max)
          return theDate;
      }
    }
  };

  this._isNotWeekendDate = function(theDate) {
    if (theDate.getDay() == 0 || theDate.getDay() == 6)
      return false;
    return true;
  };

  this._isNotFutureDate = function(theDate) {
    var date = new Date();
    var tomorrow = new Date(date.getFullYear(),date.getMonth(),date.getDate()+1);
    return theDate < tomorrow;
  };

  this._isNotBeforeXYearsBackDate = function(theDate) {
    var date = new Date();
    var waybackthen = new Date(date.getFullYear()-this.disablebeforexyearsback,date.getMonth(),date.getDate());
    return theDate >= waybackthen;
  };

  this._parseBookendDate = function (dateString) {
    var value = null;
    var stringWords = dateString.split(' ');
    if (stringWords[0].toLowerCase() === 'add' && !isNaN(stringWords[1])) {
      value = new Date();
      if (stringWords[2] === 'days') {
        value.setDate(value.getDate() + parseInt(stringWords[1]) - 1);
      } else if (stringWords[2] === 'months') {
        value.setMonth(value.getMonth() + parseInt(stringWords[1]));
      } else if (stringWords[2] === 'years') {
        value.setYear(value.getYear() + parseInt(stringWords[1]));
      }
    } else if (stringWords[0].toLowerCase() === 'subtract' && !isNaN(stringWords[1])) {
      value = new Date();
      if (stringWords[2] === 'days') {
        value.setDate(value.getDate() - parseInt(stringWords[1]) - 1);
      } else if (stringWords[2] === 'months') {
        value.setMonth(value.getMonth() - parseInt(stringWords[1]));
      } else if (stringWords[2] === 'years') {
        value.setYear(value.getYear() - parseInt(stringWords[1]));
      }
    } else if (dateString.toLowerCase() === 'today') {
      value = new Date();
      value.setDate(value.getDate() - 1);
    } else if (dateString.toLowerCase() === 'tomorrow') {
      value = new Date();
    } else if (dateString.toLowerCase() === 'yesterday') {
      value = new Date();
      value.setDate(value.getDate() - 2);
    } else {
      value = new Date(dateString);
    }
    return value;
  };
}
